//GET_TRAVEL_ALL_TICKETS
export const GET_ALL_TRAVEL_TICKETS_REQUEST = "GET_ALL_TRAVEL_TICKETS_REQUEST";
export const GET_ALL_TRAVEL_TICKETS_SUCCESS = "GET_ALL_TRAVEL_TICKETS_SUCCESS";
export const GET_ALL_TRAVEL_TICKETS_FAIL = "GET_ALL_TRAVEL_TICKETS_FAIL";

//CREATE_TRAVEL_TICKET
export const CREATE_TRAVEL_TICKET_REQUEST = "CREATE_TRAVEL_TICKET_REQUEST";
export const CREATE_TRAVEL_TICKET_SUCCESS = "CREATE_TRAVEL_TICKET_SUCCESS";
export const CREATE_TRAVEL_TICKET_FAIL = "CREATE_TRAVEL_TICKET_FAIL";

//UPDATE_TRAVEL_TICKET
export const UPDATE_TRAVEL_TICKET_REQUEST = "UPDATE_TRAVEL_TICKET_REQUEST";
export const UPDATE_TRAVEL_TICKET_SUCCESS = "UPDATE_TRAVEL_TICKET_SUCCESS";
export const UPDATE_TRAVEL_TICKET_FAIL = "UPDATE_TRAVEL_TICKET_FAIL";

//ARCHIVE_TRAVEL_TICKET
export const ARCHIVE_TRAVEL_TICKET_REQUEST = "ARCHIVE_TRAVEL_TICKET_REQUEST";
export const ARCHIVE_TRAVEL_TICKET_SUCCESS = "ARCHIVE_TRAVEL_TICKET_SUCCESS";
export const ARCHIVE_TRAVEL_TICKET_FAIL = "ARCHIVE_TRAVEL_TICKET_FAIL";

//ADD_TRAVEL_COMMENT
export const ADD_TRAVEL_COMMENT_REQUEST = "ADD_TRAVEL_COMMENT_REQUEST";
export const ADD_TRAVEL_COMMENT_SUCCESS = "ADD_TRAVEL_COMMENT_SUCCESS";
export const ADD_TRAVEL_COMMENT_FAIL = "ADD_TRAVEL_COMMENT_FAIL";

//GET_COMMENTS_FOR_ONE_TRAVEL_TICKET
export const GET_COMMENTS_FOR_ONE_TRAVEL_TICKET_REQUEST = "GET_COMMENTS_FOR_ONE_TRAVEL_TICKET_REQUEST";
export const GET_COMMENTS_FOR_ONE_TRAVEL_TICKET_SUCCESS = "GET_COMMENTS_FOR_ONE_TRAVEL_TICKET_SUCCESS";
export const GET_COMMENTS_FOR_ONE_TRAVEL_TICKET_FAIL = "GET_COMMENTS_FOR_ONE_TRAVEL_TICKET_FAIL";

//DELETE_TRAVEL_COMMENT
export const DELETE_TRAVEL_COMMENT_REQUEST = "DELETE_TRAVEL_COMMENT_REQUEST";
export const DELETE_TRAVEL_COMMENT_SUCCESS = "DELETE_TRAVEL_COMMENT_SUCCESS";
export const DELETE_TRAVEL_COMMENT_FAIL = "DELETE_TRAVEL_COMMENT_FAIL";
